export const PropertyChangedResult = {
    /** nothing changed */
    Nothing: 0,
    /** the value of one or more properties has changed */
    Value: 1,
    /** the list of properties or the state of properties (visible, editable) has changed */
    Properties: 2,
    /** the list of providers has changed (used from MultiPropertyProvider) */
    Providers: 3
};
